import React from 'react';

import { cn } from '@/utils';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      className={cn('animate-pulse rounded-md bg-black-50', className)}
      {...props}
    />
  );
}

function SkeletonText({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'animate-pulse rounded-md bg-black-50 leading-none',
        className,
      )}
      {...props}
    >
      <span className="invisible">{children}</span>
    </div>
  );
}

export { Skeleton, SkeletonText };
